<!-- Header -->
<div *ngIf="!reEnrollStudent" mat-dialog-title>
	<span translate>New Family Registration</span>
</div>
<div *ngIf="reEnrollStudent" mat-dialog-title>
	Re-Enroll Students
</div>

<!-- Body -->
<mat-dialog-content style="margin-bottom: 70px">

	<!-- If there is more than 1 year, give them a radio to select -->
	<ng-container *ngIf="!reEnrollStudent && years.length > 1">
		<div translate>For which year do you want to register students?</div>
		<div style="padding-top:15px;">
			<tyl-radio-group [(selected)]="defaultYear" arrange="vertical" [values]="years" [ids]="ids"
				[labels]="labels"></tyl-radio-group>
		</div>
	</ng-container>

	<ng-container *ngIf="reEnrollStudent">
		<div translate>Re-enrollment is currently available for the following years.</div>
		<br>
		<div translate>For which year do you want to re-enroll students?</div>
		<div style="padding-top:15px;">
			<tyl-radio-group [(selected)]="defaultYear" arrange="vertical" [values]="years" [ids]="ids"
				[labels]="labels"></tyl-radio-group>
		</div>
	</ng-container>

	<!-- If there is only one year, just display it -->
	<ng-container *ngIf="!reEnrollStudent && years.length == 1">
		<div *ngIf="defaultYear.Status == 1" translate>Students registered using this process will be registered in the
			school year currently in progress: {{defaultYear.Description}}.</div>
		<div *ngIf="defaultYear.Status == 3 || (!LoginSettings.V10 && defaultYear.Status==2)" translate>
			<div style="display: inline-block;" translate>Students registered using this process will be registered in the &nbsp;</div> 
			<div style="display: inline-block;"> {{defaultYear.Description}}&nbsp;</div>
			<div style="display: inline-block;" translate> school year.</div></div>
		<div *ngIf="defaultYear.Status == 2 && LoginSettings.V10" translate>Students registered using this process will
			be registered in the upcoming {{defaultYear.Description}} school year, which begins on
			{{defaultYear.ORStartDate|date:'MM/dd/yy'}}.</div>
	</ng-container>
</mat-dialog-content>

<!-- Footer -->
<mat-dialog-actions>

	<!-- Left -->
	<div class="flex-footer-left"></div>

	<!-- Right -->
	<div class="flex-footer-right">
		<ng-container *ngIf="years.length > 1 || reEnrollStudent">
			<error-prompt [errorList]="errorList"> </error-prompt>
			<tyl-button image="next arrow yellow.png" label="Next" (clickEvent)="modalInstanceNextClick()"></tyl-button>
			<tyl-button image="cancel.png" label="Cancel" (clickEvent)="modalInstanceCancelClick()"></tyl-button>
		</ng-container>
		<ng-container *ngIf="!reEnrollStudent && years.length == 1">
			<tyl-button image="save.png" label="OK" (clickEvent)="modalInstanceOKClick()"></tyl-button>
		</ng-container>
	</div>
</mat-dialog-actions>

<!-- Old Code -->
<!--<div class="popup">-->
<!--<div class="modal-header">-->
<!--<div class="modal-headerTitle" style="padding-left:10px;padding-top:10px;" translate>New Family Registration</div>-->
<!--</div>-->
<!--<div style="padding:10px;margin-bottom:70px;">-->
<!--<ng-container *ngIf="years.length > 1">-->
<!--<div translate>For which year do you want to register students?</div>-->
<!--<div style="padding-top:15px;">-->
<!--<tyl-radio-group [(selected)]="defaultYear"-->
<!--arrange="vertical"-->
<!--[values]="years"-->
<!--[ids]="ids"-->
<!--[labels]="labels"></tyl-radio-group>-->
<!--</div>-->
<!--</ng-container>-->
<!--<ng-container *ngIf="years.length == 1"> -->
<!--<div *ngIf="defaultYear.Status == 1" translate>Students registered using this process will be registered in the school year currently in progress: {{defaultYear.Description}}.</div>-->
<!--<div *ngIf="defaultYear.Status == 3 || (!LoginSettings.V10 && defaultYear.Status==2)" translate>Students registered using this process will be registered in the {{defaultYear.Description}} school year, which begins on {{defaultYear.ORStartDate|date:'MM/dd/yy'}}.</div>-->
<!--<div *ngIf="defaultYear.Status == 2 && LoginSettings.V10" translate>Students registered using this process will be registered in the upcoming {{defaultYear.Description}} school year, which begins on {{defaultYear.ORStartDate|date:'MM/dd/yy'}}.</div>-->
<!--</ng-container>-->
<!--</div>-->
<!--<div class="sis-app-footer">-->
<!--<div class="footerRight">-->
<!--<ng-container *ngIf="years.length > 1">-->
<!--<error-prompt [errorList]="errorList"> </error-prompt>-->
<!--<tyl-button image="next arrow yellow.png" label="Next" (clickEvent)="modalInstanceNextClick()"></tyl-button>-->
<!--<tyl-button image="cancel.png" label="Cancel" (clickEvent)="modalInstanceCancelClick()"></tyl-button>-->
<!--</ng-container>-->
<!--<ng-container *ngIf="years.length == 1">-->
<!--<tyl-button image="save.png" label="OK" (clickEvent)="modalInstanceOKClick()"></tyl-button>-->
<!--</ng-container>-->
<!--</div>-->
<!--</div>-->
<!--</div>-->